import {
  Box,
  Button,
  Grid,
  Image,
  Modal,
  Paper,
  Select,
  Text,
  createStyles,
} from "@mantine/core";
import activeLogo from "../../../assets/img/active.svg";
import { useMedplum } from "@medplum/react";
import { useEffect, useState } from "react";
import CustomBreadcrumbs from "../../../components/CustomBreadCrumbs";
import ProgressTracker from "./Steps";
import genericSvg from "../../../assets/img/generic.svg"
import InsuranceInfo from "./GenericInsuranceInfo";
import { PreAuthDetails } from "../../Availity/Dashboard-priorAuth";
import { PatientDetails, TransactionDetails } from "./CustomCards";
import FormAccordion, { AccordionData } from "./AccordianForm";
import { ServiceTag } from "../ServiceTag";
import SearchPatient from "./SelectPatient";
import { fetchCovergaeResource, findClaimObjectById, findObjectById, getClaimResponse, getCoverageEligibilityResponseForPatient, patientDetailsFromId, submitClaim } from "./ClaimService";
import { formatDate } from "@medplum/core";
import { codingSystemMap } from "../EligibiltyService";
import workflowGif from "../../../assets/img/Flow 5.gif"
import dbStoringIcon from "../../assets/img/storingDBLogo.svg";
import { IconNumber1, IconNumber2, IconNumber3, IconX } from "@tabler/icons-react";
import GenericInfoModal from "../../../components/GenericInfoModal";
import { set } from "lodash";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    padding: "16px",
    marginTop: "16px",
  },
  downloadLoader: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(0.5px)",
    zIndex: 9999,
  },
  box1: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white",
    padding: "16px",
  },
  dataBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
}));

interface Props { }

export const ClaimForm: React.FC<Props> = ({ }) => {
  const medplum = useMedplum();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [cResponse, setCResponse] = useState<any>()
  const [eligibilityIds, setEligibilityIds] = useState<any>([])
  const [preAuthIds, setPreAuthIds] = useState<any>([])
  const [selectedEligiility, setselectedEligiility] = useState<any>('')
  const [selectEligibilityDetails, setSelectedEligibilityDetails] = useState<any>()
  const [serviceType, setServiceType] = useState<any>("")
  const [patientId, setPatientId] = useState<any>()
  const [patientDetail, setPatientDetail] = useState<any>()
  const [showEligibility, setshowEligibility] = useState<boolean>(false)
  const [claimResponse, setClaimResponse] = useState<any>()
  const [selectedPreAuth, setSelectedPreAuth] = useState<any>()
  const [selctedPreAuthData, setSelctedPreAuthData] = useState<any>()
  const [covergareId, setCoverageId] = useState<any>()
  const [payerDetails, setPayerDetails] = useState<any>()
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [completed, setCompleted] = useState(0);
  const [providerInfo,setProviderInfo]=useState<any>()
  const [modalData, setModalData] = useState({
    title: "",
    sideTitle: "",
    details: [] as any,
    confirmText: "",
    onClose: () => {setShowInfoModal(false)},
    onConfirm: () => { },
  });
  const [isError, setIsError] = useState(false);
  const [reqId, setReqId] = useState<any>()
  const steps: { label: string; status: 'completed' | 'current' | 'upcoming' }[] = [
    { label: "Check Eligibility", status: currentStep === 0 ? "current" : "completed" },
    { label: "Prior Auth", status: currentStep === 1 ? "current" : currentStep > 1 ? "completed" : "upcoming" },
    { label: "Claim Submission", status: currentStep === 2 ? "current" : "upcoming" },
    { label: "Acknowledgement", status: "upcoming" },
  ];
  const handleStepCompleteCallback = () => {
    setCompleted(100);
  };

  const handleStepErrorCallback = () => {
    setIsError(true);
  };
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };
  const onPatientChange = (e: any) => {

    setPatientId(e)
  }

  useEffect(() => {
    if (selectedEligiility) {
      const cResponseToMap = findObjectById(selectedEligiility, cResponse)
      const identifierObject = cResponseToMap?.identifier.find(
        (id: any) => [codingSystemMap['pverify'], codingSystemMap['availity']].includes(id.system)
      );

      // If you want to set only the `value` property from the identifier object:
      setReqId(identifierObject?.value || '--');

      const firstCoverageReference = cResponseToMap.insuranceItems.find((item: any) => item.coverageReference)?.coverageReference;
      const firstCoverageReferenceId = firstCoverageReference ? firstCoverageReference.split('/')[1] : null;
      setCoverageId(firstCoverageReferenceId);
      setSelectedEligibilityDetails(cResponseToMap)
    }
    if (selectedPreAuth) {
      const preAuthResponse = findClaimObjectById(selectedPreAuth, claimResponse)
      setSelctedPreAuthData(preAuthResponse)
    }
    if (covergareId) {
      fetchCovergaeResourceUsingId()
    }
    // if(selctedPreAuthData){
    //   fetchProvideInfo()
    // }
  }, [selectedEligiility, selectedPreAuth, covergareId,])
  useEffect(()=>{
      fetchProvideInfo()

  },[selctedPreAuthData])
  useEffect(() => {
    getCResponseForSelctedPatient()
    fetchPatientDetails()
  }, [patientId])
  //fetch payer details using coverage id
  const fetchCovergaeResourceUsingId = async () => {
    const response = await fetchCovergaeResource(medplum, covergareId)
    setPayerDetails(response)
  }

  const fetchPatientDetails = async () => {
    const response = await patientDetailsFromId(medplum, patientId)
    setPatientDetail(response?.[0])

  }

  const fetchClaimResponse = async () => {
    const response = await getClaimResponse(medplum, patientId)
    setClaimResponse(response)
    const ids = response?.map(item => item.id);
    setPreAuthIds(ids)



  }
  useEffect(() => {
    if (currentStep === 1) {
      fetchClaimResponse()
    }
  }, [currentStep])

  const formatFormData = (formData:any) => {
    // Initialize result object
    const result = {} as any;
    
    // Iterate through each section
    formData.forEach((section: any) => {
        const sectionName = section.name;
        
        // Iterate through fields in each section
        section.fields.forEach((field: any) => {
            // Create key by combining section name and field label
            const key = field.label.toLowerCase().replace(/\s+(.)/g, (_:any, c:string) => c.toUpperCase());
            // Store the value
            result[key] = field.value;
        });
    });
    
    return result;
}

  const handleClickSubmitForm = (formData: any) => {
    const shapedFormData = formatFormData(formData)
    const resIds = {
      clResId: selectedEligiility,
      patientId: patientId,
      providerId: selctedPreAuthData?.obj?.requestor?.reference.split('/')[1],
      payerId: selctedPreAuthData?.obj?.insurer?.reference.split('/')[1],
      preAuthId: selectedPreAuth
    }
    
    setModalData({
      ...modalData,
      title: "",
      sideTitle: "Request to Availity",
      // details: details,
      onClose: () => { },
      onConfirm: () => {
        submitClaim(medplum, {...shapedFormData, ...resIds}).then((data: any) => {
          setModalData((prevData: any) => ({
            ...prevData,

            onClose: () => {
              navigate(`/admin/insurance/claims/details?id=${data.id ?? data.body.id}`);
            }
          }));
        });
      },
    })
    setShowInfoModal(true);
  }

  const getCResponseForSelctedPatient = async () => {
    const response = await getCoverageEligibilityResponseForPatient(medplum, patientId)

    // setReqId(response?.identifier.find((id: any) => [codingSystemMap['pverify'], codingSystemMap['availity']].includes(id.system)))
    setCResponse(response)
    const ids = response.map((item) => item.id);
    setEligibilityIds(ids)
  }
  const eligibilityDetails = [
    {
      title: "Status",
      data: selectEligibilityDetails?.status,
    },
    {
      title: "Payer",
      data: payerDetails?.[0]?.class?.[0]?.name ?? '--',
    },
    {
      title: "Outcome",
      data: selectEligibilityDetails?.outcome ?? '--',
    },
    {
      title: "Eligibility period",
      data: `${formatDate(payerDetails?.[0]?.period?.start)} to ${formatDate(payerDetails?.[0]?.period?.start)}`,
    },
    {
      title: "DOS",
      data: `${selectEligibilityDetails?.servicedPeriod?.start}  to ${selectEligibilityDetails?.servicedPeriod?.end}`,
    },
  ];



  // const claimResponse = {
  //   name: "Health Insurance Company",
  //   provider: {
  //     name: "Dr. Jane Smith",
  //   },
  //   type: {
  //     coding: [{ code: "C001", display: "Inpatient Care" }],
  //   },
  //   subType: {
  //     coding: [{ code: "S001", display: "Surgery" }],
  //   },
  //   preAuthPeriod: {
  //     start: "2024-01-01",
  //     end: "2024-12-31",
  //   },
  // };

  const claimRes = {
    extension: selctedPreAuthData?.obj
      ?.extension,
    preAuthRef: selctedPreAuthData?.obj
      ?.preAuthRef,
    outcome: selctedPreAuthData?.obj
      ?.outcome,
    disposition: selctedPreAuthData?.obj
      ?.disposition,
  };



const fetchProvideInfo=()=>{
  const id =selctedPreAuthData?.obj?.
    requestor?.reference?.split('/')[1] || ''
    if(id){
      const response = medplum.readResource('Organization',id
      )
      
      setProviderInfo(response)
    }
 
}

  const accordionData: any = [
    {
      name: "Patient Information",
      fields: [
        { label: "First Name", type: "text", value: patientDetail?.name?.[0]?.given?.[0] || "" },
        { label: "Last Name", type: "text", value: patientDetail?.name?.[0]?.family || "" },
        {
          label: "Gender",
          type: "dropdown",
          value: patientDetail?.gender || "",
          options: [
            { label: "Male", value: "male" },
            { label: "Female", value: "female" },
            { label: "Other", value: "other" },
          ],
        },
        { label: "Address", type: "text", value: patientDetail?.address?.[0]?.line?.[0] || "" },
      ],
    },
    {
      name: "Insurance Information",
      fields: [
        { label: "Subscriber Id", type: "text", value: payerDetails?.[0]?.subscriberId || "" },
        { label: "Plan Number", type: "text", value: payerDetails?.[0]?.class?.[0]?.value || "" },
        {
          label: "Service Type", type: "dropdown", value: "HBPC-30" , options: [
            {
              "label": "HBPC",
              "value": "HBPC-30"
            },

            {
              "label": "Chiropractic",
              "value": "Chiropractic-33"
            },

            {
              "label": "Dental Care",
              "value": "Dental Care-35"
            },

            {
              "label": "Emergency Services",
              "value": "Emergency Services-86"
            },

            {
              "label": "Pharmacy",
              "value": "Pharmacy-88"
            },

          ],
        },
        { label: "Procedure Code", type: "text", value: selectEligibilityDetails?.procedureCode || "" },
        { label: "Pre Auth Number", type: "text", value: selctedPreAuthData?.obj?.preAuthRef || "" },
      ],
    },
    {
      name: "Provider Information",
      fields: [
        { label: "Provider Name", type: "text", value: providerInfo?.response?.name || "" },
        { label: "NPI Number", type: "text", value: providerInfo?.response?.identifier.find(
          (id:any) => id.system === "http://hl7.org/fhir/sid/us-npi"
        )?.value || '--' || "" },
      ],
    },
    {
      name: "Payer Information",
      fields: [
        { label: "Payer Name", type: "text", value: payerDetails?.[0]?.class?.[0]?.name || "" },
        { label: "Policy Type", type: "text", value: payerDetails?.[0]?.class?.[0]?.type?.text || "" },

      ],
    },
  ];
  const modalSteps = [
    {
      loadText: "Converting To EDI",
      label: "Converting To EDI",
      icon: IconNumber1,
    },
    {
      loadText: "Sending Through FTP",
      label: "Sending Through FTP",
      icon: IconNumber2,
    },
    {
      loadText: "Generating Claim Response",
      label: "Generating Claim Response",
      icon: IconNumber3,
    },
  ];

  return (
    <>
      <Box className={classes.box1}>
        <Box mb={"32px"} mt={"16px"} sx={{ display: "flex", justifyContent: "space-between" }}>
          <CustomBreadcrumbs />
          <ServiceTag serviceType={serviceType} />
        </Box>
        <Box mb={"16px"} bg={"#F1F9FF"} p={"16px"} sx={{ borderRadius: "8px", width: "100%" }}>
          <ProgressTracker steps={steps} />
        </Box>
      </Box>
      <Paper className={classes.default}>
        <Box>
          <Grid mb={"16px"}>
            {currentStep === 0 ? <Grid.Col span={6}>
              <SearchPatient onChange={onPatientChange} size="md" radius="md" />
            </Grid.Col> : <></>}
            {currentStep === 1 ? <Grid.Col span={12}>
              <Select
                label="Select Pre Auth"
                size="md"
                radius={'md'}
                placeholder="Select Pre Auth"
                required
                nothingFound="No data available"

                //   value={"Availity"}
                data={preAuthIds}
                onChange={(e) => {
                  setSelectedPreAuth(e)
                  setshowEligibility(true)
                }}
              />              </Grid.Col> : <></>}

            {currentStep === 0 && <Grid.Col span={6}>
              <Select
                label="Select Eligibility"
                size="md"
                required
                radius={'md'}
                placeholder="Select Eligibility"
                //   value={"Availity"}
                nothingFound="No data available for selcted patient"

                data={eligibilityIds}
                onChange={(e) => {
                  setselectedEligiility(e)
                  // setshowEligibility(true)
                }}
              />
            </Grid.Col>}

          </Grid>
          {!selectedEligiility && <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", paddingTop: "25px" }}>
            <Image width={'190px'} src={genericSvg} />
            <Text weight={500} size={"14px"} pt={'8px'}>
              Please select a eligibility To view details</Text>
          </Box>}
          {!selectedPreAuth && currentStep === 1 && <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", paddingTop: "25px" }}>
            <Image width={'190px'} src={genericSvg} />
            <Text weight={500} size={"14px"} pt={'8px'}>
              Please select a pre auth To view details</Text>
          </Box>}
          {currentStep === 0 && selectedEligiility && <Box
            sx={{
              border: "1px solid #C9CDD3",
              padding: "16px",
              gap: "32px",
              borderRadius: "6px",
              display: "flex",
              flexDirection: "column",
            }}
          >

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Text weight={600} size={"18px"}>
                Eligibility details
              </Text>
              <Text weight={600} size={"16px"}>
                Request Id : {reqId}
              </Text>
            </Box>
            <Box>
              <InsuranceInfo eligibilityDetails={eligibilityDetails} />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>

              <Box>
                <PatientDetails patient={patientDetail} coverageReesponse={payerDetails} />
              </Box>
            </Box>
          </Box>
          }

          {/* //transaction and certificate details */}
          {currentStep === 1 && selectedPreAuth && <><Box>
            <TransactionDetails claimRes={claimRes} />
          </Box></>}
          {currentStep === 0 || currentStep === 1 ?
            <Box pt={"16px"} sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button disabled={currentStep === 0 ? !selectedEligiility : !selctedPreAuthData} onClick={handleNext}>Next</Button>
            </Box> : <></>
          }
        </Box>
        {currentStep === 2 && <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Text weight={600} size={"18px"} mb={"16px"}>
            Claim Information
          </Text>
          <FormAccordion data={accordionData} handleSubmit= {handleClickSubmitForm} />
        </Box>}

      </Paper>
      {showInfoModal && <>
        <GenericInfoModal
          isOpen={showInfoModal}
          steps={modalSteps}
          modalData={modalData}
          onClose={modalData.onClose}
          onConfirm={modalData.onConfirm}
          setIsPatientModalOpen={setShowInfoModal}
          showStepsImmediately={true}
          autoConfirm={true}
          logo={workflowGif}
          workflowProgress={true}
        />
      </>}
    </>
  );
};
